import { Editor, Node, Transforms, Range, Text } from 'slate';
import { firstNonWhitespaceIndex } from '../utils';
const indentAlignment = 2;
const indentLine = (editor, linePath, chars) => {
    Transforms.insertText(editor, ' '.repeat(chars), {
        at: { path: linePath.concat(0), offset: 0 },
    });
};
const outdentLine = (editor, linePath, chars) => {
    if (chars <= 0) {
        return;
    }
    const textNode = Node.get(editor, linePath.concat(0));
    if (!Text.isText(textNode)) {
        return;
    }
    const text = textNode.text;
    if (text.length >= chars && text.slice(0, chars) === ' '.repeat(chars)) {
        Transforms.delete(editor, {
            at: { path: linePath.concat(0), offset: 0 },
            distance: chars,
            unit: 'character',
        });
    }
};
export const calcIndent = (currentIndent, alignment) => {
    return alignment - (currentIndent % alignment);
};
export const calcOutdent = (currentIndent, alignment) => {
    if (currentIndent <= 0)
        return 0;
    return ((currentIndent - 1) % alignment) + 1;
};
export function indent(editor, reverse = false) {
    const selection = editor.selection;
    if (!selection) {
        return;
    }
    const [start, end] = Range.edges(selection);
    const iterable = Node.nodes(editor, { from: start.path, to: end.path });
    Editor.withoutNormalizing(editor, () => {
        for (const [, path] of iterable) {
            if (path.length !== 2) {
                continue;
            }
            const textNode = Node.get(editor, path.concat(0));
            let currentIndent = firstNonWhitespaceIndex(textNode.text);
            if (currentIndent === -1) {
                currentIndent = textNode.text.length;
            }
            if (reverse) {
                outdentLine(editor, path, calcOutdent(currentIndent, indentAlignment));
            }
            else {
                indentLine(editor, path, calcIndent(currentIndent, indentAlignment));
            }
        }
    });
}
export function maybeBackspaceListItem(editor) {
    if (editor.selection == null) {
        return false;
    }
    if (Range.isExpanded(editor.selection)) {
        return false;
    }
    const focus = editor.selection.focus;
    if (focus == null) {
        return false;
    }
    const focusIndex = focus.path[0];
    const focusLinePath = focus.path.slice(0, 2);
    const focusedTopLevelElement = editor.children[focusIndex];
    if (focusedTopLevelElement.parentMdastNode &&
        focusedTopLevelElement.parentMdastNode.type === 'listItem') {
        if (focus.path[1] > 0) {
            // If the cursor is not on the first line.
            return false;
        }
        if (focus.offset === 0) {
            // If the cursor is at the beginning of the line.
            return false;
        }
        const firstText = focusedTopLevelElement.children[0].children[0];
        const indents = firstNonWhitespaceIndex(firstText.text);
        if (indents === 0) {
            return false;
        }
        if (focus.offset <= indents) {
            outdentLine(editor, focusLinePath, calcOutdent(indents, indentAlignment));
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=indent.js.map